import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { BillingStatus } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { fetchBillingStatus } from '../api/billingApi';

// PARA-131 (AD-6) — ключ ['billing','me',userId] по существующему соглашению
// фич. refetchInterval параметризован: во время ожидания активации им управляет
// useActivationPolling (AC-10), в покое — false.
export function useBillingStatus(
  refetchInterval: number | false = false,
): UseQueryResult<BillingStatus> {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['billing', 'me', user?.id],
    queryFn: fetchBillingStatus,
    enabled: user !== null,
    refetchInterval,
  });
}
